import React from 'react';
import NotificationForm from './NotificationForm';
import NotificationDetail from './NotificationDetail';
import TemplateForm from './TemplateForm';

const NotificationModals = ({
  showNotificationForm,
  showDetail,
  showTemplateForm,
  selectedNotification,
  selectedTemplate,
  onCloseNotificationForm,
  onCloseDetail,
  onCloseTemplateForm,
  onSaveNotification,
  onSaveTemplate,
  onEditNotification,
  onDeleteNotification
}) => {
  return (
    <>
      {/* Modal Formulaire Notification */}
      {showNotificationForm && (
        <NotificationForm
          notification={selectedNotification}
          onClose={onCloseNotificationForm}
          onSave={onSaveNotification}
        />
      )}

      {/* Modal Détail Notification */}
      {showDetail && selectedNotification && (
        <NotificationDetail
          notificationId={selectedNotification.id}
          onClose={onCloseDetail}
          onEdit={onEditNotification}
          onDelete={onDeleteNotification}
        />
      )}

      {/* Modal Formulaire Template */}
      {showTemplateForm && (
        <TemplateForm
          template={selectedTemplate}
          onClose={onCloseTemplateForm}
          onSave={onSaveTemplate}
        />
      )}
    </>
  );
};

export default NotificationModals;
